import { BitteAiChatProps } from '@bitte-ai/types';
import { X } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../lib/utils';
import { BitteAiChat } from './BitteAiChat';
import { BitteLogo } from './icons/BitteLogo';

export const BitteWidgetChat = ({
  wallet,
  apiUrl,
  apiKey,
  historyApiUrl,
  agentId,
  options,
  customToolComponents,
  widget,
  messages,
  format,
}: BitteAiChatProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      {!isOpen && (
        <div
          className={cn(
            'bitte-cursor-pointer bitte-rounded-lg bitte-p-2 bitte-w-14 bitte-h-14 bitte-shadow-md bitte-fixed bitte-bottom-16 bitte-right-8 bitte-z-[99999]',
          )}
          style={{
            backgroundColor:
              widget?.triggerButtonStyles?.backgroundColor || '#000000',
          }}
          onClick={() => setIsOpen(true)}
        >
          {widget?.customTriggerButton ? (
            widget.customTriggerButton
          ) : (
            <BitteLogo
              style={{
                color: widget?.triggerButtonStyles?.logoColor || '#ffffff',
              }}
            />
          )}
        </div>
      )}

      <div
        className={cn(
          'bitte-fixed bitte-z-[99999] bitte-inset-0 md:bitte-top-auto md:bitte-left-auto md:bitte-bottom-16 md:bitte-right-8 bitte-w-full md:bitte-w-[380px] lg:bitte-w-[520px] bitte-rounded-lg bitte-shadow-lg bitte-overflow-hidden',
          !isOpen && 'bitte-hidden',
        )}
      >
        <div className="bitte-bg-mb-gray-250 bitte-rounded-lg bitte-overflow-hidden bitte-w-full bitte-h-full">
          <div className="bitte-bg-mb-gray-150 bitte-flex bitte-items-center bitte-justify-between bitte-py-3 bitte-px-4 bitte-border-b bitte-border-gray-800">
            <div className="bitte-flex bitte-items-center bitte-gap-2">
              {options?.agentImage ? (
                <img
                  src={options?.agentImage}
                  alt="Widget Chat Agent"
                  width={20}
                  height={20}
                  className="bitte-text-white"
                />
              ) : (
                <BitteLogo className="bitte-text-white" />
              )}

              <span className="bitte-text-white bitte-font-medium">
                {options?.agentName || 'Bitte Agent'}
              </span>
            </div>

            <X
              className="bitte-h-4 bitte-w-4 bitte-text-white bitte-cursor-pointer"
              onClick={() => setIsOpen(false)}
            />
          </div>
          <div className="bitte-h-[calc(100%-49px)] md:bitte-h-[80vh] bitte-w-full">
            <BitteAiChat
              wallet={wallet}
              apiUrl={apiUrl}
              apiKey={apiKey}
              historyApiUrl={historyApiUrl}
              agentId={agentId}
              options={{
                ...options,
                hideToolCall: true,
              }}
              customToolComponents={customToolComponents}
              widget={widget}
              isWidgetChat
              messages={messages}
              format={format}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
